import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ fontSize: '50px', color: '#333' }}>404</h1>
      <h2 style={{ fontSize: '24px', color: '#555' }}>Page Not Found</h2>
      <p style={{ fontSize: '18px', color: '#777' }}>
        Oops! The page you are looking for doesn't exist. 
      </p>
      <Link to="/" style={{ fontSize: '18px', color: '#007bff', textDecoration: 'none' }}>
        Go to Home Page
      </Link>
    </div>
  );
};

export default NotFoundPage;